/* eslint-disable no-underscore-dangle */
import Renderer from "./device-type-renderer";

const EventEmitter = require("events");
const _ = require("lodash");

class DeviceTypeComponent extends EventEmitter {
    constructor(value) {
        super();
        this._entity = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /** **************************************** */
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /** **************************************** */

    _registerListeners() {}

    _unregisterListeners() {}

    /** **************************************** */
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /** **************************************** */
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._entity = undefined;
        return prom;
    }

    /** **************************************** */
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /** **************************************** */

    /** **************************************** */
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /** **************************************** */

    /** **************************************** */
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /** **************************************** */

    setValue() {
        this.emit("Update", this._entity);
    }

    getIconData() {
        const typeBaseGroupMap = _.get(this._entity, "typeBaseGroupMap", {});
        const detectedTypeBase = _.get(this._entity, "detectedTypeBase");
        // single edge case where icon name and it's title do not match
        if (typeBaseGroupMap[detectedTypeBase] === undefined) {
            return {icon: "g-icon g-icon-default_device", title: "Unknown"};
        }
        return {
            icon: `g-icon g-icon-${_.snakeCase(typeBaseGroupMap[detectedTypeBase])}`,
            title: detectedTypeBase,
        };
    }

    /** **************************************** */
    /* END PUBLIC API METHODS                  */
    /** **************************************** */
}

export default DeviceTypeComponent;
